var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcList = function SvgIcList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_list")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_list",
    fill: "#31549B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.53,19.21 L1,19.21 C0.44771525,19.21 6.76353751e-17,18.7622847 0,18.21 C-6.76353751e-17,17.6577153 0.44771525,17.21 1,17.21 L20.53,17.21 C21.0822847,17.21 21.53,17.6577153 21.53,18.21 C21.53,18.7622847 21.0822847,19.21 20.53,19.21 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44,13.48 L1,13.48 C0.44771525,13.48 6.76353751e-17,13.0322847 0,12.48 C-6.76353751e-17,11.9277153 0.44771525,11.48 1,11.48 L20.44,11.48 C20.9922847,11.48 21.44,11.9277153 21.44,12.48 C21.44,13.0322847 20.9922847,13.48 20.44,13.48 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44,2 L1,2 C0.44771525,2 6.76353751e-17,1.55228475 0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L20.44,0 C20.9922847,3.38176876e-17 21.44,0.44771525 21.44,1 C21.44,1.55228475 20.9922847,2 20.44,2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.53,7.74 L1,7.74 C0.44771525,7.74 6.76353751e-17,7.29228475 0,6.74 C-6.76353751e-17,6.18771525 0.44771525,5.74 1,5.74 L20.53,5.74 C21.0822847,5.74 21.53,6.18771525 21.53,6.74 C21.53,7.29228475 21.0822847,7.74 20.53,7.74 Z",
    id: "Path"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_list.2a242582.svg";
export { ForwardRef as ReactComponent };